// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-sliders {
  display: flex;
}
@media (max-width: 768px) {
  .product-sliders {
    flex-wrap: wrap;
  }
}
.product-sliders > div {
  width: 50%;
}
@media (max-width: 768px) {
  .product-sliders > div {
    width: 100%;
  }
}

.additional-info {
  margin: 1.5rem 0;
  padding: 0.5rem 0;
}
.additional-info-title {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.warranty-field {
  margin: 1rem 0 1.5rem 0;
}
.warranty-field > div {
  width: 50%;
}
@media (max-width: 768px) {
  .warranty-field > div {
    width: 100%;
  }
}
.warranty-field:last-child div {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/products/product/screens/components/additional/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EAHF;IAII,eAAA;EAEF;AACF;AAAE;EACE,UAAA;AAEJ;AADI;EAFF;IAGI,WAAA;EAIJ;AACF;;AAAA;EACE,gBAAA;EACA,iBAAA;AAGF;AADE;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AAGJ;;AAEA;EACE,uBAAA;AACF;AACE;EACE,UAAA;AACJ;AACI;EAHF;IAII,WAAA;EAEJ;AACF;AACE;EACE,WAAA;AACJ","sourcesContent":[".product-sliders {\n  display: flex;\n\n  @media (max-width: 768px) {\n    flex-wrap: wrap;\n  }\n\n  & > div {\n    width: 50%;\n    @media (max-width: 768px) {\n      width: 100%;\n    }\n  }\n}\n\n.additional-info {\n  margin: 1.5rem 0;\n  padding: .5rem 0;\n\n  &-title {\n    display: flex;\n    align-items: center;\n    margin-bottom: .5rem;\n  }\n}\n\n\n.warranty-field {\n  margin: 1rem 0 1.5rem 0;\n\n  & > div {\n    width: 50%;\n\n    @media (max-width: 768px) {\n      width: 100%;\n    }\n  }\n\n  &:last-child div {\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
